/**
 * Meta (Facebook) Pixel.
 *
 * The pixel is an advertising tracker, which our cookie policy places under
 * marketing cookies and promises to use only "with your explicit consent". So
 * nothing here runs at page load: fbevents.js is only fetched once the visitor
 * has actually granted marketing consent, and PageTracker is what calls in.
 * Dropping Meta's standard snippet into index.html would have fired it on the
 * first paint, before the banner was even answered.
 */

let loaded = false;

/**
 * Injects Meta's loader and initialises the pixel. Safe to call more than
 * once - the second call does nothing.
 */
export const initMetaPixel = (pixelId) => {
  if (loaded || !pixelId || typeof window === "undefined") return;

  // Meta's own stub: queues calls made before fbevents.js has finished
  // loading, then replays them once it has.
  /* eslint-disable */
  (function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = "2.0";
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
  /* eslint-enable */

  window.fbq("init", pixelId);
  loaded = true;
};

/**
 * One PageView. This is a single-page app, so Meta's snippet firing once on
 * load would only ever record the landing page; PageTracker calls this on each
 * route change instead, the same way it reports GA pageviews.
 */
export const trackMetaPageView = () => {
  if (!loaded || typeof window === "undefined" || !window.fbq) return;
  window.fbq("track", "PageView");
};

export const isMetaPixelLoaded = () => loaded;
